









import Vue from 'vue'
import Component from 'vue-class-component'

@Component({
  name: 'Loading',
  props: {
    message: {
      type: String,
      default: 'Loading'
    }
  }
})
export default class Loading extends Vue {
}
